import { render } from "./NotFoundPage.vue?vue&type=template&id=4299eb70"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=4299eb70&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__